import gql from 'graphql-tag';

export const UPDATE_ATTACHMENT = gql`
  mutation(
      $metaDataId: Int!
      $comment: String
      $appointmentId: String!
    ) {
      updateFile (
        input: {
          metaDataId: $metaDataId,
          comment: $comment,
          appointmentId: $appointmentId,
        }
      ){
        name
        comment
    }
  }
`;
